<script>
  import Icon from '@ui/pico/icon.svelte';
  import { onMount } from 'svelte';
  import Accordion from './index.svelte';
  import { deleteSubmission, getSubmissions } from '../../../services';

  export let open = false;
  export let fid;
  let subs = [];
  let total = 0;
  let deleteTriggered = false;
  let subToDelete = null;
  let spamReportTriggered = false;
  let subToReport = null;

  onMount(async () => {
    loadSubmissions();
  });

  async function loadSubmissions() {
    const resp = await getSubmissions({ fid });
    total = resp?.total || 0;
    subs = resp?.result;
  }

  function triggerDelete(id) {
    return () => {
      subToDelete = id;
      deleteTriggered = true;
    };
  }
  function triggerSpamReport(id) {
    return () => {
      subToReport = id;
      spamReportTriggered = true;
    };
  }
  function completeSpamReport() {
    alert('you have reported ' + subToReport);
    deactivateCurrentSpamRecord();
  }
  function deactivateCurrentSpamRecord() {
    subToReport = null;
    spamReportTriggered = false;
  }
  async function completeDeletion() {
    await deleteSubmission({ id: subToDelete, fid });
    deactiveCurrentDeleteRecord();
    await loadSubmissions();
  }
  function deactiveCurrentDeleteRecord() {
    subToDelete = null;
    deleteTriggered = false;
  }
</script>

{#if spamReportTriggered}
  <dialog open>
    <article>
      <h3>Report this Submission as SPAM</h3>
      <slot>
        <p>
          Are you sure want to report this submission as SPAM: {subToReport}?
        </p>
      </slot>
      <footer>
        <a
          href="#cancel"
          on:click|preventDefault={deactivateCurrentSpamRecord}
          role="button"
          class="secondary"
        >
          Cancel
        </a>
        <a
          href="#confirm"
          on:click|preventDefault={completeSpamReport}
          role="button"
        >
          Report
        </a>
      </footer>
    </article>
  </dialog>
{/if}

{#if deleteTriggered}
  <dialog open>
    <article>
      <h3>Delete submission</h3>
      <slot>
        <p>
          Are you sure want to delete submission {subToDelete}
        </p>
      </slot>
      <footer>
        <a
          href="#cancel"
          on:click|preventDefault={deactiveCurrentDeleteRecord}
          role="button"
          class="secondary"
        >
          Cancel
        </a>
        <a
          href="#confirm"
          on:click|preventDefault={completeDeletion}
          role="button"
        >
          Delete
        </a>
      </footer>
    </article>
  </dialog>
{/if}

<Accordion {open} title="Form Submissions ({total})" icon="file-text">
  <div slot="main">
    {#if !subs || subs?.length === 0}
      <ul>
        <li>No Submissions for this form</li>
      </ul>
    {:else if subs}
      {#each subs as sub}
        <ul>
          {#if sub?.__webforma_id}
            <li>
              ID: {sub?.__webforma_id}
            </li>
          {/if}
          {#each Object.keys(sub).sort((a) => a) as field}
            {#if field !== '__webforma_id'}
              <li>
                <span>
                  {field}:
                </span>
                <div>
                  {sub[field]}
                </div>
              </li>
            {/if}
          {/each}
          {#if sub?.__webforma_id}
            <li class="cta grid">
              <button
                class="secondary"
                on:click={triggerSpamReport(sub.__webforma_id)}
              >
                <Icon size={32} name="x-octagon">Report Spam</Icon>
              </button>
              <button
                class="contrast"
                on:click={triggerDelete(sub.__webforma_id)}
              >
                <Icon size={32} name="x-square" />
                Delete
              </button>
            </li>
          {/if}
        </ul>
      {/each}
    {/if}
  </div>
</Accordion>

<style>
  :global(:root) {
    --sub-bg: #eee;
    --sub-highlight: #ccc;
  }
  :global([data-theme='dark']) {
    --sub-bg: rgba(0, 0, 0, 0.3);
    --sub-highlight: #222;
  }
  ul {
    background: var(--sub-bg);
    border-radius: 6px;
    --color: var(--contrast);
    margin: 0 1.2rem 1.2rem;
    padding: 2rem;
  }
  li {
    list-style-type: none;
  }
  li span {
    font-weight: 600;
    display: block;
    margin-top: 1.2rem;
  }
  li div {
    background: var(--sub-highlight);
    padding: 1.2rem;
  }
  li.cta {
    padding: 2rem 0 0;
  }
</style>
